<template>
  <div>
    <div class="row mb-3">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label">Prices in</label>
          <br>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="currency" id="currency1"
              @change="$store.commit('changeCurrency', 'euro')"
              :checked="currency === 'euro'"
            >
            <label class="form-check-label" for="currency1">Euro €</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="currency" id="currency2"
              @change="$store.commit('changeCurrency', 'dollar')"
              :checked="currency === 'dollar'"
            >
            <label class="form-check-label" for="currency2">Dollar $</label>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <custom-input
          label="Original Currency"
          :value="originalCurrency"
          @input="$store.commit('changeOriginalCurrency', $event)"
        />
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label">Exchanges to {{ currencyLabel }}</label>
          <div class="input-group">
            <input class="form-control"
              :value="exchangesTo"
              @input="$store.commit('changeExchangesTo', $event.target.value)"
            >
            <div class="input-group-append">
              <span class="input-group-text" v-text="currencyLabel"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" v-if="has5RPrinters">
      <label class="custom-label">5R Products</label>
      <br>
      <div class="row">
        <div class="col-sm-4" v-for="smallProduct in products5R"
          :key="smallProduct.id"
        >
          <custom-input-group
            :prependLabel="smallProduct.name"
            :appendLabel="currencyLabel"
            :value="products5R[smallProduct.id].price / 100"
            @input="$store.commit('change5RProducts', { product: smallProduct.id, value: $event.replace(',', '.') * 100})"
          />
        </div>
      </div>
    </div>
    <div class="form-group" v-if="has6RPrinters">
      <label class="custom-label">6R Products</label>
      <br>
      <div class="row">
        <div class="col-sm-4" v-for="middleProduct in products6R"
          :key="middleProduct.id"
        >
          <custom-input-group
            :prependLabel="middleProduct.name"
            :appendLabel="currencyLabel"
            :value="products6R[middleProduct.id].price / 100"
            @input="$store.commit('change6RProducts', { product: middleProduct.id, value: $event.replace(',', '.') * 100})"
          />
        </div>
      </div>
    </div>
    <div class="form-group" v-if="has8RPrinters">
      <label class="custom-label">8R Products</label>
      <br>
      <div class="row">
        <div class="col-sm-4" v-for="largeProduct in products8R"
          :key="largeProduct.id"
        >
          <custom-input-group
            :prependLabel="largeProduct.name"
            :appendLabel="currencyLabel"
            :value="products8R[largeProduct.id].price / 100"
            @input="$store.commit('change8RProducts', { product: largeProduct.id, value: $event.replace(',', '.') * 100})"
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="custom-label">Creative Products</label>
      <br>
      <custom-checkbox v-for="creativeProduct in creativeProducts"
        :key="creativeProduct.id"
        :label="creativeProduct.name"
        :value="creativeProduct.id"
        :checked="productsCreative.includes(creativeProduct.id)"
        @input="$store.commit('changeCreativeProducts', $event)"
      />
    </div>

    <div style="margin-top: 1em;" v-if="nav">
      <button type="button" class="btn btn-primary float-left"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/3`)"
        v-text="'Back'"
      />
      <button type="button" class="btn btn-primary float-right"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/5`)"
        v-text="'Next'"
      />
    </div>
    <template v-else>
      <button class="btn btn-primary float-right"
        v-if="isAdmin || isFromAuthUser"
        @click.prevent="$emit('update')"
        style="margin-bottom: 1em;"
      >
        <i class="fa fa-edit"></i> Save
      </button>
    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import StepMixin from './step-mixin'

  export default {
    props: {
      trialId: {
        default: '',
      }
    },
    mixins: [ StepMixin ],
    data() {
      return {
        creativeProducts: [],
      }
    },
    computed: {
      ...mapGetters(['has5RPrinters', 'has6RPrinters', 'has8RPrinters', 'currencyLabel']),
      ...mapState(['products5R', 'products6R', 'products8R', 'productsCreative', 'currency', 'originalCurrency', 'exchangesTo']),
    },
    mounted() {
      if (this.stepType === 'trial') {
        axios.get(`/api/creative_products?trial=${this.trialId}`).then(({data}) => {
          this.creativeProducts = data;
        })
      } else {
        axios.get(`/api/creative_products?roll_out=${this.trialId}`).then(({data}) => {
          this.creativeProducts = data;
        })
      }
    },
  }
</script>

<style scoped>
  .form-group {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep4.vue